import { memo, type ReactNode } from 'react'

import { cn } from '@/lib/utils'

import { ChatCopyButton } from './chat-copy-button.atom'
import { ChatMarkdownContent } from './chat-markdown-content.atom'
import type { ChatMessage } from './chat-message.interface'
import { ChatMessageBubble } from './chat-message-bubble.atom'
import { ChatPinButton } from './chat-pin-button.atom'

interface ChatMessageSystemProps {
  message: ChatMessage
  isPinned: boolean
  onPin?: (itemId: string) => void
  className?: string
}

/**
 * System message display component with centered styling.
 */
const ChatMessageSystemBase: React.FC<ChatMessageSystemProps> = ({
  message,
  isPinned,
  onPin,
  className,
}): ReactNode => (
  <div
    className={cn(
      'chat-message chat-message-system group flex items-center justify-center gap-1 py-2',
      className
    )}
  >
    <ChatMessageBubble variant="system">
      <ChatMarkdownContent content={message.content} variant="system" />
    </ChatMessageBubble>
    {onPin && (
      <ChatPinButton
        itemId={message.id}
        isPinned={isPinned}
        onPin={onPin}
        className="opacity-0 transition-opacity group-hover:opacity-100"
      />
    )}
    <ChatCopyButton
      content={message.content}
      className="opacity-0 transition-opacity group-hover:opacity-100"
    />
  </div>
)

export const ChatMessageSystem = memo(ChatMessageSystemBase)

ChatMessageSystem.displayName = 'ChatMessageSystem'
